import { Dialog, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: alpha(theme.palette.common.black, 0.9),
  },
  '& .GGDialogContent': {
    padding: 0,
    paddingBottom: theme.spacing(7.5),
  },
  '& .GGDialogIcon': {
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${alpha(theme.palette.secondary.contrastText, 0.5)}`,
    width: theme.spacing(6),
    height: theme.spacing(6),
    borderRadius: '50%',
  },
  '& svg': {
    color: theme.palette.secondary.contrastText,
    fontSize: theme.typography.pxToRem(16),
  },
  '& img': {
    objectFit: 'contain !important',
  },
  '& .IVOIvideo > div': {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    margin: '0 auto',
    [theme.breakpoints.up('lg')]: {
      width: '90% !important',
    },
  },
  '& .GDcarouselContainer': {
    position: 'relative',
    height: '100%',
    '& > ul': {
      height: '100%',
    },
    '& .GDArrow': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: theme.spacing(6),
      height: theme.spacing(6),
      borderRadius: '50%',
      backgroundColor: 'rgba(48, 48, 48, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.common.fogWhite,
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },

      '&.GDArrowLeft': {
        left: theme.spacing(3),
      },

      '&.GDArrowRight': {
        right: theme.spacing(3),
      },
    },
    '& .GDBoxWrapper': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
    },
  },
}));

export default StyledDialog;
